import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/gratipay': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c136.9 0 248 111.1 248 248s-111.1 248-248 248-248-111.1-248-248 111.1-248 248-248zM362.6 234.4c8.8-12 19.1-50.4-13.8-72-27.7-18.1-54.2-4.2-68.1 11.9-15.1 16.9-45.8 17.9-61.7 0-13.9-16.1-40.4-30-68.5-11.9-32.7 21.6-22.3 60.1-13.6 72l112.7 152.7z'
      }
    ]
  }
})
